import { Box, BoxProps } from '@razorpay/blade/components';

const ComponentSection = ({ children,...boxProps }: BoxProps) => {
  return (
    <Box display={'flex'} flexDirection={'column'} gap={'spacing.7'} {...boxProps}>
      {children}
    </Box>
  );
};

export default ComponentSection;
